import React from "react";
import { connect } from "react-redux";
import { MdClose } from "react-icons/md";

import Link from "../../Link/Link";

import "./AddedToCart.scss";

const closeAddedToCart = () => console.log("ciao");

const AddedToCart = ({
  addedToCartOpen,
  productImage,
  closeAddedToCart,
  primaryColor,
  uiVariantButton,
}) => {
  const handleClickClose = (event) => {
    event.preventDefault();
    closeAddedToCart();
  };

  if (addedToCartOpen) {
    return (
      <div className="added-to-cart" style={{ backgroundColor: primaryColor }}>
        <div className="container">
          <div className="content">
            <div className="img-text">
              <img
                src={productImage}
                style={{
                  borderRadius:
                    uiVariantButton === "1"
                      ? "12px"
                      : uiVariantButton === "3"
                      ? "6px"
                      : 0,
                }}
              />
              <div className="text">Prodotto aggiunto al carrello</div>
            </div>
            <div className="btn-close">
              <Link
                to="/carrello"
                className="btn btn-inverse go-to-cart"
                style={{ color: primaryColor }}
              >
                Vai al carrello
              </Link>
              <a className="btn close-cart" onClick={handleClickClose}>
                <MdClose />
              </a>
            </div>
          </div>
          {/* <div className="text">
            <img src={productImage} />
            <b className="cart-text">Prodotto aggiunto al carrello.</b>
            <Link to="/carrello" className="btn btn-inverse go-to-cart">
              Vai al carrello
            </Link>
            <a className="btn close-cart" onClick={handleClickClose}>
              &times;
            </a>
          </div> */}
        </div>
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state) => ({
  addedToCartOpen: false,
  productImage: "",
  primaryColor: state.store.singleStore.brandColor,
  uiVariantButton: state.store.singleStore.buttons,
});

export default connect(mapStateToProps, { closeAddedToCart })(AddedToCart);
